import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { Messages, DEFAULT_MESSAGE_ERROR } from './messages';
import { formatCurrency, formatDate, LocationStrategy } from '@angular/common';
import { ResultService } from '../services/result.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { takeUntil, timeout } from 'rxjs/operators';
import { LogglyLoggerService } from 'kolektor-services';
import { Location } from '@angular/common'
import { HostListener } from '@angular/core';
import { PagosData } from './../shared/models/pagosData'
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-payment-result',
    templateUrl: './payment-result.component.html',
    styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent implements OnInit, AfterViewInit {
    @Input() formPromise: Observable<any>;
    @Input() requestBody: any;
    @Input() tipoPago: any;
    private componentDestroyed$: Subject<boolean> = new Subject();

    public paymentResult = false;
    public requestFinished = false;
    public errorMessage = '';
    public codeMsg: string | number = '';
    public timeoutMessage = '';
    public transaction = '';
    public successMessage = '';
    public Messages: Messages;
    subscription: Subscription;
    isError = false;
    subdomain = environment.settings.webSubDomain;
    public paymentType: string;
    public surveyUrl: string;
    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        //Listen del botón volver atras del navegador.
        window.location.replace(event.currentTarget.location.href);
    }
    surveyId = environment.settings.surveyId;
    surveyContext;
    private pagosData: PagosData;

    constructor(
        private result: ResultService,
        private loggerService: LogglyLoggerService,
        private router: Router,
        private location: Location,
        private title: Title,
        private locationStrategy: LocationStrategy
    ) {
        history.pushState(null, null, window.location.href);
        this.locationStrategy.onPopState(() => {
            history.pushState(null, null, window.location.href);
        });

        this.Messages = new Messages();
        this.paymentType = sessionStorage.getItem('type');
        this.setSurveyData();
        this.pagosData = sessionStorage.getItem('pagosData') ? JSON.parse(sessionStorage.getItem('pagosData')) : null;
    }

    ngOnInit() {
        this.paymentResult = undefined;
        /* this.requestFinished = false; */
        if (this.result.formPromise) {
            this.subscriptionResult();
        } else {
            this.errorMessage = DEFAULT_MESSAGE_ERROR;
            this.requestFinished = true;
            this.isError = true;
        }
    }
    ngAfterViewInit(): void {
        sessionStorage.removeItem('type');
        sessionStorage.removeItem('pagosData');
    }
    subscriptionResult() {
        let url;
        const fechaPago = formatDate(new Date(), 'yyyy-MM-dd', 'es-AR');
        this.subscription = this.result.formPromise.pipe(takeUntil(this.componentDestroyed$)).subscribe(
            data => {
                this.paymentResult = data.data;
                this.timeoutMessage = data.message;
                this.transaction = data.actualizado;
                this.codeMsg = data.code;
                if (this.pagosData) {
                    window["dataLayer"].push({
                        event: 'purchase',
                        ecommerce: {
                            value: this.pagosData.importe,
                            affiliation: this.pagosData.formaDePago,
                            transaction_id: this.pagosData.nroComprobante,
                            currency: 'ARS'
                        }
                    });
                }

                //Esto se hace para que no vuelva a llamar al servicio makePayment
                // y mantener la ruta anterior en el historial
                url = this.router.createUrlTree(['form/result'], { queryParams: { pago: this.tipoPago, 'success': 'S' }, replaceUrl: true }).toString();
                this.location.go(url);
            },
            err => {
                const errCode = err.error ? err.error.code.toString() : '888';
                this.title.setTitle(this.Messages.getErrorDescription(errCode));
                this.requestFinished = true;
                if (err.name === 'TimeoutError') {
                    this.codeMsg = 888;
                    this.timeoutMessage = `Estamos procesando tu pago. Por favor, antes de volver a intentar, revisá tu cuenta bancaria o movimientos de la tarjeta en las próximas 24 horas.`;
                    this.transaction = 'General';
                    return;
                }
                const httpStatusCode = err.status;
                let code = 0;

                if (err.error) {
                    this.errorMessage = err.error.message;
                    this.transaction = err.error.actualizado;
                    code = err.error.code;
                }
                this.isError = true;
                if (!this.errorMessage) {
                    this.errorMessage = DEFAULT_MESSAGE_ERROR;
                }
                this.codeMsg = code;
                this.logError(err);
                if (this.pagosData) {
                    window["dataLayer"].push(
                        {
                            event: 'purchase',
                            ecommerce: {
                                value: this.pagosData.importe,
                                affiliation: this.pagosData.formaDePago,
                                transaction_id: this.pagosData.nroComprobante,
                                currency: 'ARS'
                            }
                        }
                    );
                }

                //Esto se hace para que no vuelva a llamar al servicio makePayment
                // y mantener la ruta anterior en el historial
                url = this.router.createUrlTree(['form/result'], { queryParams: { pago: this.tipoPago, 'success': 'N', code: this.codeMsg + '' }, replaceUrl: true }).toString();
                this.location.go(url);
            },
            () => {
                // if (result.statusCode === 400) {
                //     this.errorMessage = this.Messages.getMessage(result.statusDetail);
                // }
                this.requestFinished = true;
            });
    }

    setSurveyData() {
        const nroComprobante = sessionStorage.getItem('nroComprobante');
        if (nroComprobante) {
            this.surveyUrl = `https://encuestas.experienciaciudadanacba.gob.ar/limesurvey/index.php/435179?lang=es&quei=${nroComprobante}`;
        }
        this.surveyContext = JSON.parse(sessionStorage.getItem('surveyContext'));
        sessionStorage.removeItem('surveyContext');
    }

    private logError(error) {
        this.loggerService.send({
            type: 'HttpErrorResponse',
            error,
            requestBody: this.result.formRequest
                ? this.result.formRequest
                : 'Error al obtener token decidir'
        });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();
    }

    private setTestSession() {
        const survey = {
            "ID": "0514801046787123",
            "CUIT": "20110505621",
            "DENOMINACION": "LOZANO NARCISO ALFONSO",
            "CUITLOG": "",
            "DENOMINACIONLOG": "",
            "FECHA": "30/5/2022"
        };
        sessionStorage.setItem('surveyContext', JSON.stringify(survey));
    }

}
